import { startCase } from 'lodash';

/**
 * Converts a snake_case string to Title Case.
 * e.g. "order_type_name" → "Order Type Name"
 *
 * Returns the input unchanged when it is not a string (null, undefined, etc.).
 */
export function snakeCaseToTitleCase(value) {
    if (value == null || typeof value !== 'string') return value;
    return startCase(value);
}
